import api from './api/client';

export const workspaceService = {
    getWorkspaces: async () => {
        const response = await api.get('/api/v1/workspaces');
        return response.data;
    },

    setDefaultWorkspace: async (workspaceId) => {
        const response = await api.post(`/api/v1/workspaces/${workspaceId}/set_default`);
        return response.data;
    },

    createWorkspace: async ({ name, timezone, billingAccountId }) => {
        const payload = { workspace: { name, timezone } };
        // Only required when the user can reach more than one billing account;
        // omitted otherwise so the backend auto-inherits the single account.
        if (billingAccountId) payload.billing_account_id = billingAccountId;
        const response = await api.post('/api/v1/workspaces', payload);
        return response.data;
    },

    // Billing accounts the user may create a workspace under. When more than one
    // is returned the create form must show a picker and pass billing_account_id.
    getAvailableBillingAccounts: async () => {
        const response = await api.get('/api/v1/billing_accounts/available');
        return response.data.data;
    }
};